/**
 * CMDB / Elements Connect options often carry an `attributes` array.
 * This util normalizes access to common attributes by id.
 */

const normalizeId = (v) => String(v ?? '');
const normalizeStockValue = (value) => String(value ?? '').trim();

export const getOptionAttributeFirstDisplayValue = (option, objectTypeAttributeId) => {
  const attrs = option?.attributes;
  if (!Array.isArray(attrs) || !attrs.length) return undefined;

  const wantedId = normalizeId(objectTypeAttributeId);
  const targetAttr = attrs.find((attr) => {
    const attrId = normalizeId(attr?.objectTypeAttributeId ?? attr?.id);
    return attrId === wantedId;
  });

  const firstValue = targetAttr?.objectAttributeValues?.[0];
  return firstValue?.displayValue ?? firstValue?.value ?? firstValue?.referencedObject?.label;
};

// Convention used in this project:
// - 259: "type"
// - 304: "image url"
export const getOptionTypeLabel = (option) => getOptionAttributeFirstDisplayValue(option, '259');
export const getOptionImageUrl = (option) => getOptionAttributeFirstDisplayValue(option, '304');
export const getStockValue = (option) => getOptionAttributeFirstDisplayValue(option, '303');
export const getOptionUniverse = (option) => getOptionAttributeFirstDisplayValue(option, '756');

export const getStockBadgeLabel = (option) => {
  const normalizedStockValue = normalizeStockValue(getStockValue(option));

  if (!normalizedStockValue) {
    return null;
  }

  if (normalizedStockValue === '0') {
    return 'Stock épuisé';
  }

  return `${normalizedStockValue} en stock`;
};

export const appendStockToOptionLabel = (label, option) => {
  const stockBadgeLabel = getStockBadgeLabel(option);

  if (!stockBadgeLabel) {
    return label;
  }

  return `${label} (${stockBadgeLabel})`;
};

